// extracted by mini-css-extract-plugin
export default {"rentInfo":"RentIntro_rentInfo__qpMo4","textInfo":"RentIntro_textInfo__TMJU6","rentInfoBtns":"RentIntro_rentInfoBtns__QA2Yr","bookRide":"RentIntro_bookRide__UiwT-"};